(function(){'use strict';if(!customElements.get('lazy-section')){class LazySection extends HTMLElement{connectedCallback(){if(!('IntersectionObserver'in window)){this._reveal();return;}
this._observer=new IntersectionObserver((entries,obs)=>{entries.forEach(entry=>{if(entry.isIntersecting){this._reveal();obs.unobserve(this);}});},{rootMargin:'400px 0px',threshold:0});this._observer.observe(this);}
disconnectedCallback(){if(this._observer)this._observer.disconnect();}
_reveal(){const skeleton=this.querySelector('.skeleton-container');if(skeleton)skeleton.remove();this.dispatchEvent(new CustomEvent('lazy-section:revealed',{bubbles:true}));}}
customElements.define('lazy-section',LazySection);}
function handleImageLoad(img){if(img.complete&&img.naturalWidth>0){img.classList.remove('is-loading');}else{img.addEventListener('load',()=>img.classList.remove('is-loading'),{once:true});img.addEventListener('error',()=>img.classList.remove('is-loading'),{once:true});}}
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('img.is-loading').forEach(handleImageLoad);});document.addEventListener('lazy-section:revealed',(e)=>{e.target.querySelectorAll('img.is-loading').forEach(handleImageLoad);});if(typeof MutationObserver!=='undefined'){new MutationObserver(m=>{m.forEach(rec=>{rec.addedNodes.forEach(n=>{if(n.nodeType===1){if(n.matches&&n.matches('img.is-loading'))handleImageLoad(n);if(n.querySelectorAll)n.querySelectorAll('img.is-loading').forEach(handleImageLoad);}});});}).observe(document.body,{childList:true,subtree:true});}})();

/*
  Deferred images (see snippets/lazy-image-policy.liquid) render with data-src / data-srcset /
  data-sizes and a data-lazy-img="<mode>" marker instead of real sources:

  - "visible": native loading="lazy" starts fetching ~1250-2500px ahead of the viewport, so on the
    homepage most below-fold images used to download during initial load. These wait for an
    IntersectionObserver instead: a tight margin while the page is loading, then a wide one once
    it has loaded, so the next screens are ready before the visitor scrolls to them.
  - "interaction": images in hidden header menus. visibility:hidden keeps their layout box on
    screen, so neither native lazy loading nor an IntersectionObserver would hold them back.
    They load on the first pointer / focus / tap inside the header, before a dropdown opens.

  Revealed images get is-loading added back, so theme.js fades them in and clears the wrapper
  skeleton on load (it would have stripped is-loading at DOMContentLoaded, because an <img>
  without a src counts as complete).

  window.themeLazyImages.reveal(root) reveals every deferred image inside root right away.
*/
(function () {
  'use strict';
  var ANY = 'img[data-lazy-img]';
  var ON_VISIBLE = 'img[data-lazy-img="visible"]';
  var ON_INTERACTION = 'img[data-lazy-img="interaction"]';

  function swap(el) {
    var sizes = el.getAttribute('data-sizes');
    var srcset = el.getAttribute('data-srcset');
    var src = el.getAttribute('data-src');
    if (sizes) {
      el.setAttribute('sizes', sizes);
      el.removeAttribute('data-sizes');
    }
    if (srcset) {
      el.setAttribute('srcset', srcset);
      el.removeAttribute('data-srcset');
    }
    if (src) {
      el.setAttribute('src', src);
      el.removeAttribute('data-src');
    }
  }

  function reveal(img) {
    if (!img.hasAttribute('data-lazy-img')) return;
    img.classList.add('is-loading');
    var picture = img.parentNode;
    if (picture && picture.tagName === 'PICTURE') {
      picture.querySelectorAll('source').forEach(swap);
    }
    swap(img);
    img.removeAttribute('data-lazy-img');
  }

  function revealWithin(root, selector) {
    (root || document).querySelectorAll(selector || ANY).forEach(reveal);
  }

  window.themeLazyImages = {
    reveal: function (root) {
      revealWithin(root, ANY);
    },
  };

  // "interaction": first sign of intent anywhere in the header group.
  function watchInteraction() {
    var header = document.querySelector('.header-sections') || document.body;
    var events = ['pointerover', 'focusin', 'touchstart', 'click'];
    function onIntent() {
      events.forEach(function (name) {
        header.removeEventListener(name, onIntent, true);
      });
      revealWithin(document, ON_INTERACTION);
    }
    events.forEach(function (name) {
      header.addEventListener(name, onIntent, { capture: true, passive: true });
    });
  }

  // "visible": IntersectionObserver, widened once the page has loaded.
  function watchVisible() {
    if (!('IntersectionObserver' in window)) {
      revealWithin(document, ON_VISIBLE);
      return;
    }

    function observe(margin) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            reveal(entry.target);
          });
        },
        { rootMargin: margin + ' 0px' }
      );
      document.querySelectorAll(ON_VISIBLE).forEach(function (img) {
        io.observe(img);
      });
      return io;
    }

    // Cards parked off to the side of a horizontal slider are clipped by it, so they never count
    // as intersecting until swiped in. Once the slider itself is close, reveal everything in it.
    function observeSliders(margin) {
      var sliders = [];
      document.querySelectorAll(ON_VISIBLE).forEach(function (img) {
        var slider = img.closest('.grid--slider, .flickity-viewport, .splide__track, slider-component');
        if (slider && sliders.indexOf(slider) === -1) sliders.push(slider);
      });
      if (!sliders.length) return;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            revealWithin(entry.target, ON_VISIBLE);
          });
        },
        { rootMargin: margin + ' 0px' }
      );
      sliders.forEach(function (slider) {
        io.observe(slider);
      });
    }

    // While the page loads: only what is (nearly) on screen.
    var near = observe('100px');

    // After load: widen so the next screens (and the rest of any slider) are ready before the
    // visitor scrolls or swipes to them.
    function widen() {
      near.disconnect();
      observe('1000px');
      observeSliders('1000px');
    }
    function afterLoad() {
      if (window.themeWhenIdle) window.themeWhenIdle(widen, 3000);
      else setTimeout(widen, 1500);
    }
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad);
  }

  function start() {
    watchInteraction();
    watchVisible();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
